module.exports = __webpack_public_path__ + "static/media/questionnaire_complete.be4c31ea.png";